import { PlotGroupFiltersEnum } from '@/api/rest/resources/types/plotGroup';
import { useActivePlotGroup } from '@/components/PlotGroups/PlotGroupsContextProvider';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';
import { useOrganizationPlotGroups } from '@/pages/shared/hooks/useOrganizationPlotGroup';
import { isNullish } from '@/utils/booleans';

export const usePlotGroupFilterEndYear = (plotGroupId?: string) => {
  const { filters } = useActivePlotGroup();

  const orgId = useOrganizationId();
  const plotGroups = useOrganizationPlotGroups(orgId).data;

  if (plotGroupId) {
    const plotGroup = plotGroups?.find((pg) => pg.id === plotGroupId);
    const endDateFilters = plotGroup?.filter_definition?.field_filters?.find(
      (f) => f.field === PlotGroupFiltersEnum.end_date,
    );

    return !isNullish(endDateFilters);
  }

  return !isNullish(filters?.end_date);
};
